import React from "react"
import { graphql, Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import styled from 'styled-components'

import Layout from "../components/layout-v2"
import Seo from "../components/seo"
import ParticleBG from "../components/particle-bg"

import LongLeftArrow from '../images/white-arrow-left.svg'
import LongRightArrow from '../images/white-arrow-right.svg'

const LabArchive = ({ data: { featuredLabPost, mainLabPosts, pageContent, bannerOne, bannerTwo }, pageContext: { nextPagePath, previousPagePath },}) =>  {

  // Randomize Banner Image
  const max = 2;
  const rand = Math.floor(Math.random() * max);

  const featuredPosts = featuredLabPost.nodes
  const mainPosts = mainLabPosts.nodes
  const content = pageContent.edges
  const prevLink = previousPagePath
  const nextLink = nextPagePath

    return (
        <Layout>
          {content.map(page => ( 
              <Seo 
              title={page.node.SEOmeta.metaTitle} 
              description={page.node.SEOmeta.metaDescription}
              keywords={page.node.SEOmeta.metaKeywords}
              ogTitle={page.node.SEOmeta.ogTitle} 
              ogDescription={page.node.SEOmeta.ogDescription}
              ogImage={page.node.SEOmeta.ogImage.localFile.childImageSharp.fluid}
              twitterTitle={page.node.SEOmeta.twitterTitle} 
              twitterDescription={page.node.SEOmeta.twitterDescription}
              twitterImage={page.node.SEOmeta.twitterImage.localFile.childImageSharp.fluid}
              />
          ))}
          <MainPage>
            <TitleSection>
              <div class="header-border">
                <h1>Point of View</h1>
                <p>Predictions and trends and patterns. Oh my! This is how we think.</p>
              </div>
              <div class={rand === 0 ? "hero-banner banner-1" : "hero-banner banner-2"}>
                  <div
                  data-sal="fade"
                  data-sal-duration="1000"
                  data-sal-easing="ease">
                    <GatsbyImage className={"hero-bg hero-bg-1"} image={bannerOne.childImageSharp.gatsbyImageData} alt={"Hahn.Agency POV Background"}/>
                    <GatsbyImage className={"hero-bg hero-bg-2"} image={bannerTwo.childImageSharp.gatsbyImageData} alt={"Hahn.Agency POV Background"}/>
                  </div>
              </div>
            </TitleSection>
            
            <FeaturedSection>
              <h2>Featured Article</h2>
              {featuredPosts.map(featuredPost => {
                return (
                  <article
                  itemScope
                  itemType="http://schema.org/Article"
                  >
                    <div>
                      <Link to={`/pov/${featuredPost.slug}`} itemProp="url">
                        <GatsbyImage image={featuredPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData} alt={featuredPost.featuredImage.node.title}/>
                      </Link>
                    </div>
                    <div>
                      <Link to={`/pov/${featuredPost.slug}`}><h3 dangerouslySetInnerHTML={{ __html: featuredPost.title }} itemProp="headline" /></Link>
                      <div class="excerpt" dangerouslySetInnerHTML={{ __html: featuredPost.excerpt }} itemProp="description" />
                      <p class="author">By {featuredPost.LabAuthor.labAuthorName}</p>
                    </div>
                  </article>
                )
              })}
            </FeaturedSection>
            <MainLoop>
              <h2>Lab Articles</h2>
              {mainPosts.map(mainPost => {
                return (
                  <article
                  itemScope
                  itemType="http://schema.org/Article"
                  >
                    <Link to={`/pov/${mainPost.slug}`} itemProp="url">
                      <GatsbyImage image={mainPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData} alt={mainPost.featuredImage.node.title}/>
                    </Link>
                    <Link to={`/pov/${mainPost.slug}`}><h3 dangerouslySetInnerHTML={{ __html: mainPost.title }} itemProp="headline" /></Link>
                    <div class="excerpt" dangerouslySetInnerHTML={{ __html: mainPost.excerpt }} itemProp="description" />
                    <p class="author">By {mainPost.LabAuthor.labAuthorName}</p>
                  </article>
                )
              })}
            </MainLoop>
            <Pagination>
              <div className={previousPagePath && ( "active" )}>
                <Link to={previousPagePath} className={"prev-link"}></Link>  
              </div>
              <div className={nextPagePath && ( "active" )}>
                <Link to={nextPagePath} className={"next-link"}></Link>
              </div>
            </Pagination> 
          </MainPage>
        </Layout>
    );
          
}

const MainPage = styled.div`
  padding: 0 20px;
`

const TitleSection = styled.header`
    position: relative;
    max-width: 1320px;
    width: 100%;
    padding: 40px;
    margin: 0 auto; 
    margin-top: 20px;
    margin-bottom: 60px;
    background-color: #000;
    .header-border {
      border: 10px solid #fff;
      padding: 120px;
      position: relative;
      z-index: 10;
    }
    .hero-banner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      div {
        height: 100%;
      }
      .gatsby-image-wrapper {
        height: 100%;
      }
      img {
        width: 100%;
        height: 100%;
      }
      .hero-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          visibility: hidden;
      }
      &.banner-1 {
          .hero-bg-1 {
              opacity: 1;
              visibility: visible;
          }
      }
      &.banner-2 {
          .hero-bg-2 {
              opacity: 1;
              visibility: visible;
          }
      }
    }
    h1 {
        font-size: 100px;
        color: #fff;
        margin-top: 0;
        margin-bottom: 20px;
        position: relative;
        z-index: 2;
        text-align: center;
        &:hover {
          cursor: default;
        }
    }
    p {
        font-family: "Work Sans";
        color: #fff;
        font-size: 44px;
        font-weight: 400;
        line-height: 1.3;
        margin-bottom: 0;
        position: relative;
        z-index: 2;
        text-align: center;
        &:hover {
          cursor: default;
        }
    }
    @media(max-width:1000px) {
      max-width: 700px;
      padding: 45px;
      .header-border {
        padding: 80px;
      }
      h1 {
        font-size: 60px;
      }
      p {
        font-size: 24px;
      }
    }
    @media(max-width: 767px) {
      max-width: 500px;
      padding: 20px;
      margin-bottom: 20px;
      h1 {
        font-size: 44px;
      }
      p {
        font-size: 18px;
        line-height: 1.4;
      }
      .header-border {
        padding: 40px 20px;
      }
    }
`

const FeaturedSection = styled.section`
  max-width: 1170px;
  width: 100%;
  padding: 0px;
  margin: 0 auto;
  h2 {
    font-family: Nobel, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 36px;
    line-height: 50px;
    color: #2B2520;
    margin-top: 70px;
    margin-bottom: 30px;
  }
  article {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    > div {
      a {
        text-decoration: none;
      }
      img {
        transition: opacity 500ms ease 0s, transform 1s ease 0s !important;
      }
      &:first-child {
        max-width: 670px;
        width: 100%;
        max-height: 400px;
      }
      &:last-child {
        max-width: 470px;
        width: 100%;
        h3 {
          font-family: Nobel, sans-serif;
          font-weight: 700;
          font-style: normal;
          font-size: 40px;
          line-height: 50px;
          color: #2B2520;
          margin-top: 0;
          margin-bottom: 20px;
          transition-duration: 0.3s;
        }
        div.excerpt {
          p {
            font-family: "Work Sans";
            font-size: 24px;
            line-height: 34px;
            font-weight: 400;
            color: #777C7C;
            margin-top: 0px;
            margin-bottom: 20px;
          }
        }
        p.author {
          font-family: "Work Sans";
          font-size: 16px;
          line-height: 34px;
          font-weight: 400;
          color: #2B2520;
          margin-top: 0px;
          margin-bottom: 0px;
        }
      }
    }
    &:hover {
      img {
        transform: scale(1.1);
      }
      h3 {
        color: rgb(219, 65, 64) !important;
      }
    }
  }
  @media(max-width:1230px) {
    max-width: 700px;
    h2 {
      text-align: center;
    }
    article {
      flex-wrap: wrap;
      > div {
        &:first-child {
          max-width: 100%;
          overflow: hidden;
          margin-bottom: 35px;
        }
        &:last-child {
          max-width: 100%;
        }
        .gatsby-image-wrapper {
          width: 100%;
        }
      }
    }
  }
  @media(max-width:767px) {
    max-width: 500px;
    h2 {
      margin-top: 30px;
      margin-bottom: 25px;
      font-size: 24px;
      line-height: 34px;
    }
    article {
      > div {
        &:first-child {
          margin-bottom: 10px;
        }
        &:last-child {
          h3 {
            font-size: 24px;
            line-height: 30px;
            margin-bottom: 5px;
          }
          div.excerpt {
            p {
              font-size: 18px;
              line-height: 28px;
              margin-bottom: 0;
            }
          }
          p.author {
            font-size: 16px;
          }
        }
      }
    }
  }
`

const MainLoop = styled.section`
  max-width: 1170px;
  width: 100%;
  padding: 0px;
  margin: 0 auto;
  margin-top: 70px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 10px solid #C44C4A;
  h2 {
    font-family: Nobel, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 36px;
    line-height: 50px;
    color: #2B2520;
    margin-top: 70px;
    margin-bottom: 30px;
    width: 100%;
  }
  article {
    max-width: 570px;
    width: 100%;
    margin-bottom: 50px;
    .gatsby-image-wrapper {
      max-height: 340px;
      margin-bottom: 30px;
      img {
        transition: opacity 500ms ease 0s, transform 1s ease 0s !important;
      }
    }
    a {
      text-decoration: none;
    }
    h3 {
      font-family: Nobel, sans-serif;
      font-weight: 700;
      font-style: normal;
      font-size: 30px;
      line-height: 40px;
      color: #2B2520;
      margin-top: 0;
      margin-bottom: 0px;
      transition-duration: .3s;
    }
    div.excerpt {
      p {
        font-family: "Work Sans";
        font-size: 18px;
        line-height: 28px;
        font-weight: 400;
        color: #777C7C;
        margin-top: 0px;
        margin-bottom: 0px;
      }
    }
    p.author {
      font-family: "Work Sans";
      font-size: 16px;
      line-height: 34px;
      font-weight: 400;
      color: #2B2520;
      margin-top: 0px;
      margin-bottom: 0px;
    }
    &:hover {
      img {
        transform: scale(1.1);
      }
      h3 {
        color: rgb(219, 65, 64) !important;
      }
    }
  }
  @media(max-width:1230px) {
    max-width: 700px;
    h2 {
      text-align: center;
    }
    article {
      max-width: 100%;
      .gatsby-image-wrapper {
        width: 100%;
      }
    }
  }
  @media(max-width:767px) {
    max-width: 500px;
    margin-top: 20px;
    h2 {
      margin-top: 30px;
      margin-bottom: 25px;
      font-size: 24px;
      line-height: 34px;
    }
    article {
        .gatsby-image-wrapper {
          margin-bottom: 10px;
        }
        h3 {
          font-size: 24px;
          line-height: 30px;
          margin-bottom: 5px;
        }
        div.excerpt {
          p {
            font-size: 18px;
            line-height: 28px;
            margin-bottom: 0;
          }
        }
        p.author {
          font-size: 16px;
        }
    }
  }
`

const Pagination = styled.section`
  max-width: 1170px;
  width: 100%;
  padding: 0px;
  margin: 110px auto;
  margin-top: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    height: 48px;
    width: 48px;
    margin: 0 10px;
    a {
      display: block;
      height: 48px;
      width: 48px;
      background-color: #EAEAEA;
      background-size: 50%;
      background-position: center;
      background-repeat: no-repeat;
      transition-duration: .3s;
    }
    &.active {
      a {
        background-color: #C44C4A;
        &:hover {
          background-color: #2B2520;
          cursor: pointer;
        }
      }
    }
  }
  .prev-link {
    background-image: url(${LongLeftArrow});
  }
  .next-link {
    background-image: url(${LongRightArrow});
  }
`

export default LabArchive

export const pageQuery = graphql`
  query WordPressLabArchive($offset: Int!, $postsPerPage: Int!) {
    featuredLabPost: allWpLabPost(
      filter: {categories: {nodes: {elemMatch: {slug: {eq: "featured"}}}}}
      sort: { fields: [date], order: DESC }
    ) {
      nodes {
        title
        excerpt
        slug
        featuredImage {
          node {
            title
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 670
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
        LabAuthor {
          labAuthorName
        }
      }
    }
    mainLabPosts: allWpLabPost(
      filter: {categories: {nodes: {elemMatch: {slug: {ne: "featured"}}}}}
      sort: { fields: [date], order: DESC }
      limit: $postsPerPage
      skip: $offset
    ) {
      nodes {
        title
        excerpt
        slug
        featuredImage {
          node {
            title
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 570
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
        LabAuthor {
          labAuthorName
        }
      }
    }
    pageContent: allWpCustomPage(filter: {databaseId: {eq: 1857}}) {
      edges {
        node {
          SEOmeta {
              metaTitle
              metaDescription
              metaKeywords
              ogTitle
              ogDescription
              ogImage {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 1320, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              twitterTitle
              twitterDescription
              twitterImage {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 1320, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
        }
      }
    }
    bannerOne: file(relativePath: { eq: "pov-bg-02.jpg" }) {
        childImageSharp {
            gatsbyImageData(
                width: 2000
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
        }
    }
    bannerTwo: file(relativePath: { eq: "pov-bg-02.jpg" }) {
        childImageSharp {
            gatsbyImageData(
                width: 2000
                placeholder: TRACED_SVG
                formats: [AUTO, WEBP, AVIF]
              )
        }
    }
  }
`